module.exports = __webpack_public_path__ + "img/horizontal_6_6_7016.c1cbabdf.png";